import { render } from "./HomePage.vue?vue&type=template&id=aabaa486"
const script = {}

import "./HomePage.vue?vue&type=style&index=0&id=aabaa486&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__